import { useEffect } from "react";
import SignUpAddInfo from "../components/login/SignUpAddInfo";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet-async";

function SignUpAddInfoScreen() {
    const [cookies] = useCookies(["KMNM", "KMUI"]);

    useEffect(() => {
        const iamport = document.createElement("script");
        const jquery = document.createElement("script");
        iamport.src = "https://cdn.iamport.kr/js/iamport.payment-1.1.7.js";
        jquery.src = "https://code.jquery.com/jquery-1.12.4.min.js";
        document.head.appendChild(iamport);
        document.head.appendChild(jquery);
        return () => {
            document.head.removeChild(iamport);
            document.head.removeChild(jquery);
        };
    }, []);

    const onClickRegist = () => {
        // const data: PaymentData = {
        //     name: cookies.KMNM,
        //     email: cookies.KMUI,
        // };
        // Upgrade(data);
    };
    return (
        <>
            <Helmet>
                <title>회원가입 추가정보 - 모두의지도</title>
                <meta name="description" content="간편가입의 추가정보를 입력하세요" />
            </Helmet>
            <div>
                <SignUpAddInfo />
            </div>
        </>
    );
}

export default SignUpAddInfoScreen;
